<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click.native="openDialog"
      >
        <v-icon>add_circle_outline</v-icon>
      </v-btn>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >

        <v-card>
          <v-toolbar
            card
            dense
            color="primary"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon color="white">library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
              :loading="loader"
            >
              <v-icon color="white">save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon color="white">add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
              :loading="deleteloader"
            >
              <v-icon color="white">delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon color="white">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon color="white">keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon color="white">keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon color="white">last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="white">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <blister-bom
              ref="eblisterMasterForm"
              v-bind="dialogData"
            ></blister-bom>
          </v-card-text>

          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="blisterScrapID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td class="text-xs-left">{{ props.item.blisterComponent }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.description1 }}</td>
        <!-- <td class="text-xs-left">{{ props.item.sublot }}</td> -->
        <td class="text-xs-left">{{ props.item.batchSize }}</td>
        <!-- <td class="text-xs-left">{{ props.item.packSize }}</td> -->
        <td class="text-xs-left">{{ props.item.bomtype }}</td>
        <td class="text-xs-left">{{ props.item.uom }}</td>
        <td class="text-xs-left">{{ props.item.scrapUom }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getBlisterScrapMasters, getBlisterScrapMaster, createBlisterScrapMaster, updateBlisterScrapMaster, deleteBlisterScrapMaster } from '@/api/scrapMaster';
import BlisterBom from '@/pages/scrap/BlisterBOM';
import { postProdBOM } from '@/api/navService';
import GlobalMessage from '@/constant'
export default {
  components: {
    BlisterBom,


  },
  data: () => ({

    dialog: false,
    dialogData: null,
    loader: false,
    deleteloader: false,
    search: '',

    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'BlisterComponent', value: 'blisterComponent', align: 'left' },
      { text: 'Description', value: 'description', align: 'left' },
      { text: 'Description1', value: 'description1', align: 'left' },
      // { text: 'Sublot', value: 'itemNo', align: 'left' },
      { text: 'BatchSize', value: 'batchNo', align: 'left' },
      //  { text: 'PackSize', value: 'packSize', align: 'left' },
      { text: 'BOMType', value: 'bOMType', align: 'left' },
      { text: 'UOM', value: 'uOM', align: 'left' },
      { text: 'ScrapUOM', value: 'scrapUOM', align: 'left' },
      // { text: 'BatchSize', value: 'batchSize', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    // plasticbagsitems: [],
    // blisterTypeitems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      blisterScrapId: -1,
      blisterComponent: '',
      description: '',
      description1: '',
      sublot: '',
      batchSize: '',
      packSize: '',
      bomtype: -1,
      uom: -1,
      scrapUom: -1,
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      blisterScrapLine: [],
      blisterAllowable: []
    },
    defaultItem: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      blisterScrapId: -1,
      blisterComponent: '',
      description: '',
      description1: '',
      sublot: '',
      batchSize: '',
      packSize: '',
      bomtype: -1,
      uom: -1,
      scrapUom: -1,
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      blisterScrapLine: [],
      blisterAllowable: []

    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: '....' },
      // { title: 'Post' },
      // { title: 'Delete' },
      { title: 'Print' }
    ],

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {

    initialize () {
      this.loader = true;
      getBlisterScrapMasters('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.$refs.eblisterMasterForm.$refs.bomform.form = this.editedItem;
      this.$refs.eblisterMasterForm.$refs.bomform.initialize();
      this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.blisterScrapId = this.editedItem.blisterScrapId;
      this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.initialize();

      this.$refs.eblisterMasterForm.$refs.allowableform.blisterScrapId = this.editedItem.blisterScrapId;
      this.$refs.eblisterMasterForm.$refs.allowableform.initialize();

      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteBlisterScrapMaster(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {
      getBlisterScrapMaster(this.searchItem)
        .then(response => {
          if (response.data.blisterScrapId != null) {
            this.editedItem = response.data;
            this.editedItem.date = new Date().toISOString().substr(0, 10);
            this.editedItem.loginUser = 'Arun';
            this.editedItem.isLogin = 'yes-1';
            this.$refs.eblisterMasterForm.$refs.bomform.form = this.editedItem;
            this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.blisterScrapId = this.editedItem.blisterScrapId;
            this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.initialize();

            this.$refs.eblisterMasterForm.$refs.allowableform.blisterScrapId = this.editedItem.blisterScrapId;
            this.$refs.eblisterMasterForm.$refs.allowableform.initialize();

            let index = this.gridItems.map(item => item.blisterScrapId).indexOf(response.data.blisterScrapId)
            this.editedIndex = index;
          }
          else {
             window.getApp.$emit('APP_API_SUCCESS', 'No More record to view');
          }
        })
        .catch(error => {
          // this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.blisterScrapId;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.blisterScrapId;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.blisterScrapId;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.blisterScrapId;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    openDialog () {
      this.add();
      this.dialog = true;
    },
    add () {

      this.editedItem.blisterScrapId = -1;
      this.editedItem.valid = false;
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.editedItem.blisterComponent = null;
      this.editedItem.description = null;
      this.editedItem.description1 = '';
      this.editedItem.itemNo = '';
      this.editedItem.batchNo = '';
      this.editedItem.packSize = '';
      this.editedItem.bomtype = null;
      this.editedItem.uom = null;
      this.editedItem.scrapUom = null;
      this.editedItem.batchSize = null;
      this.editedItem.dddedByUserId = 2;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = null;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserId = 2;
      this.editedItem.modifiedDate = new Date();
      this.editedItem.blisterScrapLine = [];
      this.$refs.eblisterMasterForm.$refs.bomform.form = this.editedItem;

      this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.blisterScrapId = this.editedItem.blisterScrapId;
      this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.scrapLines = [];
      this.$refs.eblisterMasterForm.$refs.allowableform.blisterScrapId = -1;
      this.$refs.eblisterMasterForm.$refs.allowableform.gridItems = [];
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      this.deleteloader = true;
      let index = this.editedIndex;

      deleteBlisterScrapMaster(this.$refs.eblisterMasterForm.$refs.bomform.form)
        .then(() => {
          this.$refs.eblisterMasterForm.$refs.bomform.loader = false;
          this.deleteloader = false;
          this.add();
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.deleteloader = false;
          this.$refs.eblisterMasterForm.$refs.bomform.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    postBlisterBOM () {
      postProdBOM(this.editedItem)
        .then(response => {
          this.loader = false;
           window.getApp.$emit('APP_API_SUCCESS', 'Blister BOM Posted successfully to NAV');
          
        })
        .catch(error => {
          this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    save () {
      this.editedItem = this.$refs.eblisterMasterForm.$refs.bomform.form;
      this.editedItem.blisterScrapLine = this.$refs.eblisterMasterForm.$refs.bomform.$refs.scraplineform.scrapLines;
      this.editedItem.blisterAllowable = this.$refs.eblisterMasterForm.$refs.allowableform.gridItems;

      // this.$refs.eblisterMasterForm.$refs.bomform.loader = true;
      if (this.$refs.eblisterMasterForm.$refs.bomform.$refs.bomformvalid.validate()) {

        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateBlisterScrapMaster(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              // this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
              this.postBlisterBOM();
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
              //this.$refs.eblisterMasterForm.$refs.bomform.loader = false;
            });
        } else {
          this.editedItem.blisterScrapId = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createBlisterScrapMaster(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;             
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.blisterScrapID).indexOf(response.data.blisterScrapID)
              this.editedIndex = index;
               window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
              this.postBlisterBOM();
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
      else {
        console.log('Validation failed.')
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterScrapList.vue